import RCPSCookies from 'utils/RCPSCookies';

const isGenAIPRSKillswitchEnabled = () => Sephora.configurationSettings?.genAIPRS?.isEnabled;

const isGenAIPRSEnabledSelector = () => isGenAIPRSKillswitchEnabled() && RCPSCookies.isRCPSBeautyChatPRS();

export {
    isGenAIPRSEnabledSelector, isGenAIPRSKillswitchEnabled
};
